import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import 'photoswipe/dist/photoswipe.css';

const imageGalleryComponent = () => {

    // check if .imageGallery__gallery exists
    if (!document.querySelector('.imageGallery__gallery')) {
        return;
    }

    const lightbox = new PhotoSwipeLightbox({
        gallery: '.imageGallery__gallery',
        children: 'a',
        pswpModule: () => import('photoswipe/dist/photoswipe.esm.js')
      });
      
      lightbox.init();

};

/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    imageGalleryComponent();

};

export default init;
